<!-- Navigation -->
    <div class="header">
        <header class="full-width">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 mainNavCol">
                        <!-- logo -->
                        <div class="logo mainNavCol">
                            <a routerLink="/">
                                <img src="assets/img/LA Burgers logo-1_page-0001.png" class="img-fluid logoImg"  alt="Logo">
                            </a>
                        </div>
                        <!-- logo -->
                        <div class="main-search mainNavCol">
                            <form class="main-search search-form full-width">
                                <div class="row">
                                    <!-- location picker -->
                                    <div class="col-lg-6 col-md-5">
                                        
                                        <a href="javascript:void(0)" class="delivery-add p-relative"> <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                                            <span class="">Suite 306, 111 Overton Rd,
                                                Williams Landing VIC 3027</span>
                                        </a>
                                        <!-- <div class="location-picker">
                                            <input type="text" class="form-control" placeholder="Enter a new address">
                                        </div> -->
                                    </div>
                                    <!-- location picker -->
                                    <!-- search -->
                                    <!-- <div class="col-lg-6 col-md-7">
                                        <div class="search-box padding-10">
                                            <input type="text" class="form-control" placeholder="Pizza, Burger, Chinese">
                                        </div>
                                    </div> -->
                                    <!-- search -->
                                </div>
                            </form>
                        </div>
                        <div class="right-side fw-700 mainNavCol">
                            <div class="gem-points">
                                <a  routerLink="/" > 
                                    <span>Home</span>
                                </a>
                            </div>
                            <div class="gem-points">
                                <a routerLink="/menu"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">
                                    <span>Menu</span>
                                </a>
                            </div>
                            <div class="gem-points">
                                <a href="javascript:void(0)" routerLink="/about"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" > 
                                    <span>About Us</span>
                                </a>
                            </div>
                            <div class="gem-points">
                                <a  href="#" routerLink="/news"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">
                                    <span>News</span>
                                </a>
                            </div>
                            <div class="gem-points">
                                <a href="javascript:void(0)" href="#" routerLink="/contact"  routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}"> 
                                    <span>Contact Us</span>
                                </a>
                            </div>
                            <div class="catring parent-megamenu">
                                <a href="javascript:void(0)"> <span> <i class=""></i></span>
                                    <i class="fas fa-bars"></i>
                                </a>
                                <div class="megamenu"#megaMenu>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="row">
                                               
                                                <div class="col-lg-8 col-md-7">
                                                    <div class="row">
                                                        <div class="col-lg-3 col-sm-6">
                                                            <div class="menu-style">
                                                                <div class="menu-title">
                                                                    <h6 class="cat-name"><a routerLink="/" (click)="closeMenu()" class="text-light-black">Home</a></h6>
                                                                </div>
                                                            
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-sm-6">
                                                            <div class="menu-style">
                                                                <div class="menu-title">
                                                                    <h6 class="cat-name"><a routerLink="/menu" (click)="closeMenu()" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" class="text-light-black">Menu</a></h6>
                                                                </div>
                                                             
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-sm-6">
                                                            <div class="menu-style">
                                                                <div class="menu-title">
                                                                    <h6 class="cat-name"><a href="#" routerLink="/about" (click)="closeMenu()" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" class="text-light-black" class="text-light-black">About Us</a></h6>
                                                                </div>
                                                              
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-sm-6">
                                                            <div class="menu-style">
                                                                <div class="menu-title">
                                                                    <h6 class="cat-name"><a href="#" routerLink="/news" (click)="closeMenu()"class="text-light-white fw-500" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" class="text-light-black">News</a></h6>
                                                                </div>
                                                             
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-sm-6">
                                                            <div class="menu-style">
                                                                <div class="menu-title">
                                                                    <h6 class="cat-name"><a href="#" routerLink="/contact" class="text-light-white fw-500" (click)="closeMenu()" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" class="text-light-black">Contact Us</a></h6>
                                                                </div>
                                                             
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <div class="col-sm-12 mobile-search">
                   
                    </div>
                </div>
            </div>
        </header>
    </div>
    <div class="main-sec"></div>
